import { Button } from '@repo/ui/components/ui/button';
import { showErrorToast } from '@repo/ui/components/ui/error-toast';
import { truncateLongEmail } from '@repo/ui/lib/truncate-long-email';
import { Check, Link2 } from 'lucide-react';
import { useCallback, useState } from 'react';
import { toast } from 'sonner';
import { permissions as permifyPermissions } from '../../../../../../../api/src/permify/constants';
import { CandidateProps } from '../component';
import {
  CONTACT_BUTTON_TEST_ID,
  CONTACT_EMAIL_TRUNCATE_LENGTH,
} from './constants';

interface Props extends CandidateProps {
  truncate?: boolean;
}

export function CandidateInfoContact({ candidate, truncate }: Props) {
  const [copied, setCopied] = useState(false);

  const email = candidate.profile.contactEmail;

  const copyToClipboard = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      toast('Email address copied.', {
        className: 'pl-6 pr-8 py-6',
      });
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      showErrorToast({ title: 'Unable to copy email' });
    }
  }, [email]);

  const truncateEmail = truncate
    ? truncateLongEmail(email, CONTACT_EMAIL_TRUNCATE_LENGTH)
    : email;

  return (
    <div
      className="bg-white"
      data-permission={permifyPermissions.openCalls.contactCandidates}
    >
      <div className="px-4 py-6 text-lg font-bold">Contact</div>
      <div className="grid grid-cols-[1fr,2fr]">
        <p className="flex items-center p-4 border-b border-zinc-100">Email</p>
        <div className="flex items-center justify-between p-4 border-b border-zinc-200">
          <span className="whitespace-nowrap truncate text-ellipsis">
            {truncateEmail}
          </span>
          <div className="flex justify-end items-center">
            <Button
              className="hover:bg-transparent sm:hover:bg-accent"
              variant="ghost"
              onClick={copyToClipboard}
              role="copy-button"
              data-testid={CONTACT_BUTTON_TEST_ID}
            >
              {!copied ? <Link2 /> : <Check />}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
